import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { defer, Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { PartnerBaseDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-base-dto';
import { PartnerService } from 'src/app/api/services';
import { PartnerChangeData, PartnerChangeDialogData } from 'src/app/components/aftale/models';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
    selector: 'app-edit-multiple-partner-dialog',
    templateUrl: './edit-multiple-partner-dialog.component.html',
    styleUrls: ['./edit-multiple-partner-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditMultiplePartnerDialogComponent implements OnInit {
  form: UntypedFormGroup;
  allPartners: PartnerBaseDto[];
  activePartners: PartnerBaseDto[];
  today: Date = new Date();
  tomorrow: Date = new Date();
  unsubscribe$ = new Subject<void>();

  get partnerNo() {
    return this.form.get('partnerNo');
  }

  get validFrom() {
    return this.form.get('validFrom');
  }

  constructor(
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
    private partnerService: PartnerService,
    private fb: UntypedFormBuilder,
    private dialog: MatDialogRef<EditMultiplePartnerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PartnerChangeDialogData
  ) {}

  ngOnInit(): void {
    this.tomorrow.setDate(this.today.getDate() + 1);
    this.getPartnere$.subscribe(
      (result) => {
        this.allPartners = result;
        this.activePartners = this.allPartners.filter((x) => this.isPartnerActive(x, this.tomorrow));
      },
      (error) => {
        this.errorHandler.HandleError(error);
      }
    );

    this.form = this.fb.group({
      partnerNo: [null, [Validators.required]],
      validFrom: [this.tomorrow, [Validators.required]],
    });

    this.validFrom.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((value: Date) => {
      this.getPartnere$.subscribe((result) => {
        this.activePartners = result.filter((x) => this.isPartnerActive(x, value));
        this.form.patchValue({
          partnerNo: null,
        });
      });
    });
  }

  private isPartnerActive(partner: PartnerBaseDto, date: Date): boolean {
    return (
      (partner.validTo == null || new Date(partner.validTo) > date) && (partner.validFrom == null || new Date(partner.validFrom) < date)
    );
  }

  getPartnere$ = defer(() => {
    this.loader.show();
    return this.partnerService
      .getAllPartnere({
        caller: EGIS_SERVICE_CALLER,
      })
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => {
          this.loader.hide();
        })
      );
  });

  save() {
    let data: PartnerChangeData = {
      partnerNo: this.partnerNo.value,
      validFrom: this.validFrom.value,
    };
    this.dialog.close(data);
  }

  cancel() {
    this.dialog.close(null);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }
}
